import { Box, Typography } from "@mui/material";
import DataContent from "../../../components/DataContent";
import { DataCodeEnum } from "../../../constants/enum";
import PageContentEditor from "../../../components/PageContentEditor";

const IndicatorsCompatibility = () => {
  return (
    <Box m={2}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          color="primary"
          variant="h5"
          sx={{
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Numerology Indicators - Compatibility
        </Typography>
      </Box>
      <Box
        sx={{
          height: "calc(100vh - 80px)",
        }}
      >
        <PageContentEditor
          dataCode={DataCodeEnum.NUMEROLOGY_INDICATORS_COMPATIBILITY}
          dataName={"Numerology Indicators - Compatibility"}
        />
      </Box>
      {/* <DataContent
        code={DataCodeEnum.NUMEROLOGY_INDICATORS_COMPATIBILITY}
        name="Numerology Indicators - Name"
        fields={[
          {
            code: "number",
            name: "Number",
          },
          {
            code: "description",
            name: "Description",
          },
          {
            code: "is_compatible",
            name: "is compatible",
          },
          {
            code: "is_least_compatible",
            name: "is least compatible",
          },
        ]}
      /> */}
    </Box>
  );
};

export default IndicatorsCompatibility;
